export function assert(condition: boolean, errorMsg: string): asserts condition {
	if (!condition) {
		throw new Error(errorMsg);
	}
}
